module.exports = __webpack_public_path__ + "static/media/empty_blog.79a47643.png";